import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["item", "icon"];

  connect() {
    this.openIndex = null;

    this.iconTargets.forEach(icon => {
      icon.innerHTML = this.plusIcon();
    });

    // Wire each trigger button to its panel and mark everything collapsed
    // (WCAG 4.1.2 Name, Role, Value).
    this.buttons().forEach((button) => {
      const i = button.dataset.index;
      button.setAttribute("aria-expanded", "false");
      const panel = this.itemTargets[parseInt(i)];
      if (panel) {
        if (!panel.id) panel.id = `faq-panel-${i}`;
        button.setAttribute("aria-controls", panel.id);
      }
    });
  }

  buttons() {
    return Array.from(
      this.element.querySelectorAll('[data-action*="support-faq#toggle"]')
    );
  }

  toggle(event) {
    const index = parseInt(event.currentTarget.dataset.index);

        this.itemTargets.forEach((item, i) => {
            const icon = this.iconTargets[i];
            const isTarget = i === index;
            const isOpen = item.style.maxHeight && item.style.maxHeight !== "0px";

            if (isTarget) {
            if (isOpen) {
                item.style.maxHeight = "0px";
                icon.innerHTML = this.plusIcon();
                this.openIndex = null;
            } else {
                item.style.maxHeight = item.scrollHeight + "px";
                icon.innerHTML = this.minusIcon();
                this.openIndex = index;
            }
            } else {
            item.style.maxHeight = "0px";
            icon.innerHTML = this.plusIcon();
            }
        });

        // Only the open panel's trigger is expanded.
        this.buttons().forEach((button) => {
          button.setAttribute(
            "aria-expanded",
            String(parseInt(button.dataset.index) === this.openIndex)
          );
        });
    }


  plusIcon() {
    return `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z" fill="#020D19"/>
        <path d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V18C12.75 18.41 12.41 18.75 12 18.75Z" fill="#020D19"/>
    </svg>`;
    }

  minusIcon() {
    return `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z" fill="#020D19"/>
    </svg>`;
  }
}
